import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";
import { 
    DocumentsCategoryTypes, 
    DocumentsConfidentialityLevels, 
    DocumentsTypes 
} from "src/modules/data-protection/constants";

const FilteringComponent = ({
    t,
    onChange
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        type: undefined,
        category: undefined,
        confidentialityLevel: undefined,
        title: undefined
    });

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'type',
                title: 'Type',
                icon: <i className="ri-exchange-line" />,
                isLoading: false,
                defaultValue: tableFilters?.type,
                data: DocumentsTypes.map((dType) => {
                    return {
                        id: dType.value,
                        ...dType
                    }
                }),
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.title)
                }
            },
            {
                type: 'radio_list',
                name: 'category',
                title: 'Category',
                icon: <i className="ri-price-tag-3-line" />,
                isLoading: false,
                defaultValue: tableFilters?.category,
                data: DocumentsCategoryTypes.map((category) => {
                    return {
                        id: category.value,
                        ...category
                    }
                }),
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.title)
                }
            },
            {
                type: 'radio_list',
                name: 'confidentialityLevel',
                title: 'Confidentiality Level',
                icon: <i className="ri-shield-line" />,
                isLoading: false,
                defaultValue: tableFilters?.confidentialityLevel,
                data: DocumentsConfidentialityLevels.map((level) => {
                    return {
                        id: level.value,
                        ...level
                    }
                }),
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.title)
                }
            },
            {
                type: 'search_textbox',
                name: 'title',
                title: 'Search',
                icon: <i className="ri-terminal-box-line" />,
                defaultValue: tableFilters?.title,
                options: {
                    placeholder: t('Search by title'),
                    typingDelay: 750
                },
                displayIndependently: true,
                onFilterChange: (value) => {
                    setTableFilters((currentState) => ({...currentState, title: value}))
                }
            }
        ]
    }, [
        tableFilters,
        t
    ]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {}
            if ('type' in filters) {
                result.type = filters.type !== 'all' ? filters.type : undefined
            }

            if ('category' in filters) {
                result.category = filters.category !== 'all' ? filters.category : undefined
            }

            if ('confidentialityLevel' in filters) {
                result.confidentialityLevel = filters.confidentialityLevel !== 'all' ? filters.confidentialityLevel : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                type: undefined,
                category: undefined,
                confidentialityLevel: undefined,
                title: independentTabsData?.title
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [ 
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='type'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);